<template>
    <Sidebar :initValue="open" :title="editedEntity.title || 'new dream'" :saveButton="showFooter" @close="$emit('close')"  @enterClick="$root.$emit('dreamSidebarFooterSaveClicked')">
      <EditForm
        :editedEntity="editedEntity"
        :showDeadline="showDeadline"
        @close="$emit('close')"
      />

      <template v-if="showFooter" v-slot:sidebar-footer>
        <vs-button color="dark" class="px-20" @click="$root.$emit('dreamSidebarFooterSaveClicked')">save</vs-button>
     </template>
    </Sidebar>
</template>
<script>
import EditForm from './EditForm'
import trackAnalytics from '@/helpers/trackAnalytics'
import Sidebar from '@/views/Self-Improvee/Generic/Sidebar'
import _ from 'lodash'

export default {
  components: {
    Sidebar,
    EditForm
  },
  props: ['editedEntity', 'open', 'showDeadline'],
  watch: {
    'editedEntity': {
      immediate: true,
      async handler (editedEntity) {
        this.localEntity = editedEntity
      }
    },
    // 'showSection': {
    //   immediate: true,
    //   async handler (showSection) {
    //     if (showSection === 'get inspired') {
    //       this.filter = 'get inspired'
    //     } else {
    //       this.filter = 'new routine'
    //     }
    //   }
    // }
  },
  data () {
    return {
      // filter: ['new routine'],
      // filterOptions: ['new routine', 'get inspired'],
      localEntity: {},

    }
  },
  computed: {
    showFooter () {
      return true
    },
    custom () {
      return _.includes(this.filter, 'new task')
    },
    getInspired () {
      return _.includes(this.filter, 'get inspired')
    },
    edit () {
      return !!_.get(this.editedEntity, 'id')
    },
  },
  methods: {
    inpiredBy (entity) {
      this.localEntity = entity
      this.filter = 'new task'
      trackAnalytics(this, 'app_action', 'get inspired - task')
    }
  }
}
</script>
<style>
</style>
